module.exports = {"loginUrl":"/"};


//////////////////
// WEBPACK FOOTER
// external "{\"loginUrl\":\"/\"}"
// module id = IkUC
// module chunks = 2